import React, { useState } from 'react'
import { setConfig } from 'react-hot-loader'

setConfig({ pureSFC: true })

export const ModalContext = React.createContext()

const ModalProvider = ({ children }) => {
  const [activeForm, setActiveForm] = useState(null)

  const setActive = formId => setActiveForm(formId)

  return (
    <ModalContext.Provider value={{ activeForm, setActive }}>
      {children}
    </ModalContext.Provider>
  )
}

export default ModalProvider
